import Vue from 'vue'
import axios from "axios"
import { createStore } from "@/store";
const store = createStore();
import {
    Message,
    MessageBox
} from "element-ui";
import router from '@/router'
import appConfig from "../../app.config"
// import {
//   getToken
// } from "@/plugins/auth";




// 创建axios实例
const service = axios.create({
    baseURL: appConfig.apiPath, // api的base_ur
    timeout: 99888888 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
    config => {
        function getCookie(name) {
            var strcookie = document.cookie; //获取cookie字符串
            var arrcookie = strcookie.split("; "); //分割
            //遍历匹配
            for (var i = 0; i < arrcookie.length; i++) {
                var arr = arrcookie[i].split("=");
                if (arr[0] == name) {
                    return arr[1];
                }
            }
            return "";
        }
        config.headers["Content-Type"] ='application/json'; // 让每个请求携带自定义token 请根据实际情况自行修改
        // console.log('axios-token',store.state.user.token)
        if (store.getters.token) {
            config.headers["Authorization"] = store.getters.token; // 让每个请求携带自定义token 请根据实际情况自行修改
           
            
        } else {
            config.headers["Authorization"] = store.state.user.token;
        }
        return config;
    },
    error => {
        // Do something with request error
        Promise.reject(error);
    }
);

// respone拦截器
service.interceptors.response.use(
    response => {

        // console.log('axios',response.headers.applicationmode)

        //获取是不是为基础版
        // if (response.headers.applicationmode) {
        //     if (response.headers.applicationmode == 'complete') {
        //         Vue.prototype.isSimple = false
        //     } else {
        //         Vue.prototype.isSimple = true
        //     }
        // } else {
        //     Vue.prototype.isSimple = true
        // }

        /**
         * code为非00000是抛错 可结合自己业务进行修改
         */
        //u0002 用户未登录
        const res = response.data;
        if (res.httpcode != "200") {
            // Message({
            //   message: res.msg,
            //   type: "error",
            //   duration: 3 * 1000
            // });

            // 
            // if (res.httpcode == 'ad000121') {
            //   MessageBox.confirm(
            //     "登录异常,请重新登录！",
            //     "", {
            //       confirmButtonText: "重新登录",
            //       cancelButtonText: "取消",
            //       type: "warning"
            //     }
            //   ).then(() => {
            //     window.location = BaseUrl +'/community/noticelist';
            //   });
            // }
            // return Promise.reject("error");
            return response.data;
        } else {
            // Message({
            //   message: '请求成功',
            //   type: "success",
            //   duration: 3 * 1000
            // });
            return response.data;
        }
    },
    error => {
        // console.log("err:", error.response.status); // for debug
        // let msg = error.message.indexOf('timeout') != -1 ? '请求超时！' : error.message
        // console.log(error)
        
        if (localStorage.getItem('token') == 'undefined') {
            localStorage.removeItem("loginInfo");
            sessionStorage.removeItem("roleCode");
            localStorage.removeItem("token");
            localStorage.removeItem("createUid");
            localStorage.removeItem("powers");
            localStorage.removeItem("firstPage");
            // sessionStorage.removeItem("picLove");
            window.location.href = '/loginNoToken'
        }
        console.log('错误信息', error)
        console.log('错误信息', error.response)
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
            Message({
                message: "接口请求超时！",
                type: "error",
                duration: 2 * 1000
            });
            return "";
        }
        if (error.response.status === 401) {

            if (store.state.user.isMobile) {
                if (window.location.href.indexOf('mobileAtlas') !== -1) {
                    return
                }
                window.location.href = '/timeout'
            } else {
                localStorage.removeItem("loginInfo");
                sessionStorage.removeItem("roleCode");
                localStorage.removeItem("token");
                localStorage.removeItem("createUid");
                localStorage.removeItem("powers");
                localStorage.removeItem("firstPage");
                // sessionStorage.removeItem("picLove");

                // setTimeout(() => {
                if (window.location.href.indexOf('eastnet') == -1) {
                    window.location.href = '/loginNoToken'
                }
                // }, 888);
            }
            return "";

        } else if (error.response.status === 503 || error.response.status === 502) {
            // Message({
            //     message: "服务器错误，请联系管理员！",
            //     type: "error",
            //     duration: 2 * 1000
            // });
            // localStorage.removeItem("loginInfo");
            // sessionStorage.removeItem("roleCode");
            // localStorage.removeItem("createUid");
            // localStorage.removeItem("powers");
            // localStorage.removeItem("firstPage");
            // sessionStorage.removeItem("picLove");
            // window.location.href = '/renewal'

            return
        }

        return Promise.reject(error);
    }
);

export default service;